import { AllPurposeLink } from '@components/all-purpose-link'
import { DetailText, HeadlineText } from 'design-configuration/components'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import React from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { ArtistGridItemProps } from '../types'
import { gridItemTransition } from '@components/grid'

export const ArtistListGridItem = ({ item }: { item: ArtistGridItemProps }): React.ReactElement => {
  const [hovered, setHovered] = React.useState(false)
  const [imageLoadded, setImageLoaded] = React.useState(false)
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={gridItemTransition}
      className="gap-y-2xs relative flex flex-col items-start text-left"
    >
      <AnimatePresence>
        {hovered ? (
          <motion.div
            className="bottom-2xl pointer-events-none absolute -left-[60px] z-20 hidden h-[104px] w-[800px] items-center sm:-left-[120px] sm:flex sm:h-[208px]"
            initial={{ opacity: 0, transform: 'translateY(20px)' }}
            animate={{ opacity: 1, transform: 'translateY(0px)' }}
            exit={{ opacity: 0, transform: 'translateY(-20px)' }}
            transition={{ duration: 0.4 }}
          >
            <div className="relative h-full w-[100px] flex-shrink-0 sm:w-[200px]">
              <ImageWithCustomLoader
                src={item.artist.avatarUrl}
                alt={item.artist.name}
                fill
                className="object-cover drop-shadow-lg"
                sizes="200px"
              />
            </div>
            {item.artist.featuredTokenUrl ? (
              <div className="relative flex h-full w-full items-center">
                {!imageLoadded ? <div className="bg-surface-container h-full w-[100px] sm:w-[200px]"></div> : null}
                <ImageWithCustomLoader
                  src={item.artist.featuredTokenUrl || ''}
                  alt={`${item.artist.name} featured token`}
                  onLoad={() => {
                    setImageLoaded(true)
                  }}
                  fill
                  sizes="200px"
                  style={{ objectFit: 'contain', objectPosition: 'left' }}
                  className="drop-shadow-lg"
                />
              </div>
            ) : null}
          </motion.div>
        ) : null}
      </AnimatePresence>
      <AllPurposeLink
        href={item.artist.url}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <HeadlineText className="font-light">{item.artist.name}</HeadlineText>
      </AllPurposeLink>
      <DetailText className="text-on-surface-variant -bottom-sm absolute font-medium">
        {item.artist.subtext?.toUpperCase()}
      </DetailText>
    </motion.div>
  )
}
